import { handle } from '../main.js'

export default element => {
  handle(element, 'describedby')
}
